import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "../i18n";
import { CheckMark } from "./Logo";

export default function ClosingCTA() {
  const { t } = useLang();
  const navigate = useNavigate();

  return (
    <section className="py-24 md:py-44 bg-crema" data-testid="closing-section">
      <div className="mx-auto max-w-5xl px-5 md:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.5, rotate: -8 }}
          whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="inline-flex mb-8"
        >
          <CheckMark size={52} />
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-black tracking-tight text-charcoal text-4xl md:text-6xl leading-[1.02] max-w-3xl mx-auto"
          data-testid="closing-headline"
        >
          {t.closing.headline}
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-12"
        >
          <button
            onClick={() => navigate("/book")}
            className="group inline-flex items-center gap-3 rounded-full bg-teal text-crema text-lg font-semibold pl-8 pr-7 py-5 hover:brightness-110 transition-all duration-300 shadow-[0_16px_50px_-16px_rgba(15,110,86,0.7)]"
            data-testid="closing-cta"
          >
            {t.closing.cta}
            <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
